<template>
  <TableTemplate class="OverviewOrder"
    v-model="mappedContent"

    :columns="tableColumns"
    :columnVariables="tableColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :max="max"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    :on-row-click="viewMarketingItem"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Marketing"
        :alwaysShowMultiSelectCheckbox="false"
        :refetch="refetch"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
      </TableHeader>
      <div class="d-flex">
        <FormSearchSelector
          v-model="website"
          class="website-search"
          id="website"
          placeholder="Zoek website..."
          endpoint="/api/websites"
          titleField="domainname"
          :selectFirst='true'

          :infinite-scrolling="true"
          :table="true"

          v-slot="item"
        >
          <div class="p-1 item">
            {{ item.domainname }}
          </div>
        </FormSearchSelector>

        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
      <CardTabs class="card-tabs"
        v-model="state"
        :tabs="tabs"
      />
    </template>

    <template v-if="loaded" #row-action="{item}">
      <TableActionDropdown class="drop" :item="item" :options="options(item, freshRefetch)"/>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        :title="state === 'campaign' ? 'Geen campagnes gevonden' : 'Geen advertentiegroepen gevonden'"
        description="Zorg ervoor dat je een website hebt geselecteerd"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600"><g transform="matrix(42.857142857142854,0,0,42.857142857142854,0,0)"><g><path d="M12.84,12.07,1.17,8A1,1,0,0,1,.5,7.09V6a1,1,0,0,1,.67-.94L12.84,1a.5.5,0,0,1,.66.47V11.6A.5.5,0,0,1,12.84,12.07Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.48,10.57A2.75,2.75,0,0,1,3,10.25V8.66" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></g></g></svg>
      </EmptyStatePlaceholder>
    </template>

  </TableTemplate>
</template>

<script>

/*
  <template #cell-status="{value}">
    <button
      type='button'
      class="btn"
      :class="value === 'active' ? 'btn-success' : 'btn-danger'"
    >
      {{ value }}
    </button>
  </template>

  <template #cell-orderAmount="{value}">
    <span class="order-amount">
      {{ `€ ${(value + "").replace(/\./, ",")}` }}
    </span>
  </template>

  <template #cell-orderNumber="{value}">
    <CopyableElement :skeleton-class="skeletonClass"
      :value="value"
      :message="`Succesvol ${value} ordernummer gekopieerd!`"
    >
      {{ value }}
    </CopyableElement>
  </template>
*/

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import FormSelect from "src/components/Inputs/FormSelect.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import CardTabs from "src/layout/CardTabs.vue"
import TableCell from "src/components/Table/TableCell.vue"
import TableDatePickerField from '../components/Inputs/TableDatePickerField.vue'
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import CopyableElement from '../layout/CopyableElement.vue'
import MultiplePageSizesSelection from '@/layout/Table/MultiplePageSizesSelection.vue'
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import RefreshBtn from '../layout/RefreshBtn.vue'
import FormSearchSelector from '../components/Inputs/FormSearchSelector.vue'

import table from "src/mixins/table"
import keepScroll from "src/mixins/keepScroll"

/*
  <div class="delete-icon cancel-icon" @click="confirmDelete(item)">
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  </div>
*/

import faker from 'faker'

const generateFake = () => {
  const createMarketingObj = () => {
    return {
        "campaign": {
          "id": faker.datatype.uuid(),
          "name": faker.internet.userName(),
          "resource_name": faker.internet.userName(),
          "status": 0,
          "advertising_channel_type": 0,
          "bidding_strategy_type": 0,
          "campaign_budget": faker.datatype.number(),
        },
        "metrics": {
          "all_conversions": faker.datatype.number(),
          "average_cost": faker.datatype.number(),
          "average_cpc": faker.datatype.number(),
          "average_time_on_site": faker.datatype.number(),
          "bounce_rate": faker.datatype.number(),
          "cost_micros": faker.datatype.number(),
          "cost_per_conversion": faker.datatype.number(),
          "ctr": faker.datatype.number(),
          "engagement_rate": faker.datatype.number(),
          "engagements": faker.datatype.number(),
          "impressions": faker.datatype.number()
        }
      }
  }

  return {
    "campaigns": Array.from({ length: 25 }).map(createMarketingObj),
    "adGroups": Array.from({ length: 25 }).map(createMarketingObj),
  }
}

import { metrics, campaign, defaultSizes } from "../utils/marketing-fields"

export default {
  metaInfo: {
    title: "Marketing",
  },
  components: {
    HeaderButton,
    CardTabs,
    TableHeader,
    TableMainSearchField,
    RefreshBtn,
    MultiplePageSizesSelection,
    TableCell,
    TableDatePickerField,
    CopyableElement,

    TableActionDropdown,
    FormSelect,
    FormSearchSelector,
    TableTemplate,
    TableSearchField,
    EmptyStatePlaceholder,
    FormSearchSelector,
  },
  mixins: [
    tableFieldOptions,
    keepScroll,
    table({
      pageReference: 'marketing',
      
      defaultColumnSizes: defaultSizes,
      columnTranslationMaps: {
        ...metrics, ...campaign,
      },
      defaultColumns: [
        "Naam", "Naam van de bron", "Toestand", "Type advertentiekanaal", "Type biedstrategie", "Campagne Budget",
      ],
      // generateFake,

      defaultSort: "orderDate",
      defaultOrder: "desc",
      page_size: 15,
      manualPagination: true,
      layoutFilter: true,
      params: {
        orderNumber: "",
        website: "",
        customer: "",
        orderAmount: "",
        search: "",
        email: "",
        orderInitialDate: "",
        orderFinalDate: "",
        page_size: 20,
        state: "campaign",
      },
      routeTriggers: ["website"],
      toISOFields: ["orderInitialDate", "orderFinalDate"],
      route: vm => `/api/websites/${vm.website}/campaigns`,

    }),
  ],
  data() {
    return {
      meta: {},

      /**
       * [ Mixin keepScroll ] - localStorageKey: Unique key(one per page) that will be used as a reference to set/get the element's distance from the top
       */
      localStorageKey: "position_scroll_marketing"
    }
  },
  methods: {
    async cancelOrder(uid) {
      this.$handlePromise(
        this.axios.delete(`/api/orders/${uid}`)
      )
      this.$success("Bestelling geannuleerd!")
      this.freshRefetch()
    },
    viewMarketingItem(item) {
      if (this.removeCursor) return;
      const referenceRowTarget = document.getElementById(`table-row-${item.uid}`)
      referenceRowTarget && this.setLocalStorageTopDistance({ target: referenceRowTarget})

      this.$pushModal({
        modal: "Campaign",
        toBind: { item },
      })
    },
    getWebsiteList(websites) {
      return websites.reduce((str, site) => {
        return !str.length ? `, ${site.domainname}` : site.domainname
      }, "")
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.cancelOrder(item.uid),
        {
          title: "Annuleer bestelling",
          description: `Are you sure you want to cancel the <b>${item.email || item.customer}</b> order?`,
          buttonSave: "Annuleren",
        }
      )
    },
    options(item, freshRefetch) {
      const editAndResend = {
        click: () => this.viewMarketingItem(item),
        id: "edit-and-resend",
        name: "Wijzig en stuur opnieuw",
        icon: "nc-icon nc-settings-tool-66",
      }

      const viewMarketingItem = {
        click: () => this.viewMarketingItem(item),
        id: "view",
        name: "Order bekijken",
        icon: "nc-icon nc-zoom-split",
      }

      switch (this.state) {
        case "NOT_SENT": {
          return [
            {
              click: () => this.viewMarketingItem(item),
              id: "edit",
              name: "Wijzig order",
              icon: "nc-icon nc-settings-tool-66"
            },
            {
              click: async () => {
                if (await this.$handlePromise(
                  this.axios.delete(`/api/orders/${item.uid}`)
                )) {
                  this.$success("Bestelling geannuleerd!")
                  freshRefetch()
                }
              },
              id: "cancel",
              name: "Annuleer order",
              icon: "nc-icon nc-simple-remove",
            },
          ]
        }
        case "SENT_TO_POSTNL": {
          return [
            editAndResend,
            {
              click: async () => {
                this.$pushModal({
                  modal: "OverviewOrderMarkAsBeingShipped",
                  toBind: {
                    order: item,
                    callback: freshRefetch,
                  }
                })
              },
              id: "mark-as-being-shipped",
              name: "Markeren als verzonden naar Klant",
              icon: "nc-icon nc-map-big",
            },
          ]
        }
        case "SHIPPED": {
          return [viewOrder]
        }
        case "CANCELED": {
          return [editAndResend]
        }
      }
    },
    isOlderThanTwoDays(orderDate) {
      const diff = new Date().getTime() - new Date(orderDate).getTime()
      return diff > MILISECONDS_IN_TWO_DAYS
    },
  },
  computed: {
    tabs() {
      const meta = this.meta
      const data = this.result
      
      return [
        {
          name: "Campaigns",
          id: 'campaign',
          number: data && data.campaigns && data.campaigns.length,
        },
        {
          name: "Ad groups",
          id: 'adgroup',
          number: data && data.adGroups && data.adGroups.length,
        },
      ]
    },
    sortOptions() {
      return [
        {
          str: "Asc",
          value: "asc",
        },
        {
          str: "Desc",
          value: "desc",
        },
      ]
    },

    filteredResult() {
      let data = this.result
      data = (this.state !== "campaign" ? data.adGroups : data.campaigns)
      if (!data || !data.length) return;

      console.log("campaign", data[0])
      const arr = data.map(item => ({ ...(item.campaign || item.ad_group), ...item.metrics }))
      const property = this.sort
      const order = this.order

      const names = ["name", "resource_name"]
      property && arr.sort((a, b) => {
        if (names.includes(property)) {
          return order === "asc"
            ? a[property].localeCompare(b[property])
            : b[property].localeCompare(a[property])
        }

        return this.sortNumber(a[property], b[property], false, order)
      })

      console.log(arr)
      return arr
    },
    mappedContent() {
      return this.tableResult

      /* if (this.state === "campaign") return

      return arr.map(item => ({
        ...item,
        isOlderThanTwoDays: this.isOlderThanTwoDays(item.orderDate),
      })) */
    },
    table() {
      return this.$refs.table
    },
    capitalize() {
      return [false, false, false, false, false, false, false]
    },
  },
  watch: {
    state() {
      this.page = 1
    },
  },
}

</script>

<style>

.OverviewOrder tr > td.first-child > span {
  display: block;
  padding-left: 14px !important;
}

</style>

<style scoped>

.item {
  transition-duration: .15s;
}

.item:hover {
  background-color: rgba(245,245,245);
}

.older-than-two-days-warning {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.card-tabs {
  transform: translateY(9px);
}

.card-title {
  margin-top: 0;
  margin-bottom: 18px;
}

.website-search {
  width: 100%;
}

.website-search::v-deep input {
  height: 34px;
}

@media (min-width: 992px) {
  .website-search {
    width: initial;
  }
}

</style>
